import React from 'react';
import PropTypes from 'prop-types';
import ContestFinalistDrawer from './contest-finalist-drawer';
import ContestFinalistFullscreenDrawer from './contest-finalist-fullscreen-drawer';
import DrawerApp from './drawer-app';
import ConfirmRemoveContestFinalistModal from './confirm-remove-contest-finalist-modal';
import connectFinalistDrawer from './connected/connect-finalist-drawer';

class ContestFinalistDrawerApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalShowing: false,
            finalistToRemove: {},
            finalistsNeedingPopup: [],
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.confirmRemoveFinalist = this.confirmRemoveFinalist.bind(this);
        this.confirmationPopupTimer;
        this.confirmationPopupTiming = 1500;
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (this.props.finalists.length < nextProps.finalists.length) {
            this.handleConfirmationPopup(this.props.finalists, nextProps.finalists);
        }
    }

    handleConfirmationPopup(oldFinalists, newFinalists) {
        const finalistsNeedingPopup = newFinalists.filter(el => {
            return oldFinalists.indexOf(el) < 0 ? el : null;
        });

        if (this.confirmationPopupTimer) {
            clearTimeout(this.confirmationPopupTimer);
        }

        this.setState({ finalistsNeedingPopup }, () => {
            this.confirmationPopupTimer = setTimeout(() => {
                this.setState({ finalistsNeedingPopup: [] });
            }, this.confirmationPopupTiming);
        });
    }

    hideModal() {
        this.setState({
            isModalShowing: false,
            finalistToRemove: {},
        });
    }

    showModal(user) {
        this.setState({
            isModalShowing: true,
            finalistToRemove: user,
        });
    }

    confirmRemoveFinalist(userId) {
        this.props.onRemoveFinalist(userId);
        this.hideModal();
    }

    render() {
        return (
            <div>
                <DrawerApp
                    finalistsNeedingPopup={this.state.finalistsNeedingPopup}
                    onRemoveFinalistClick={this.showModal}
                    drawer={ContestFinalistDrawer}
                    fullscreenDrawer={ContestFinalistFullscreenDrawer}
                    {...this.props}
                />
                {this.renderModal()}
            </div>
        );
    }

    renderModal() {
        if (this.state.isModalShowing) {
            return (
                <ConfirmRemoveContestFinalistModal
                    user={this.state.finalistToRemove}
                    onConfirm={() => this.confirmRemoveFinalist(this.state.finalistToRemove.userId)}
                    onCancel={this.hideModal}
                />
            );
        }
    }
}

ContestFinalistDrawerApp.propTypes = {
    onRemoveFinalist: PropTypes.func.isRequired,
    finalists: PropTypes.array.isRequired,
};

export default connectFinalistDrawer(ContestFinalistDrawerApp);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/contest-finalist-drawer-app.jsx